// extracted by mini-css-extract-plugin
export default {"layoutAside":"Layout_layoutAside__HFe6P"};